module.exports = __webpack_public_path__ + "static/00053.95538641.jpg";